var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxnull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkboxnull"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container",
    x: 3.5,
    y: 3.5,
    width: 17,
    height: 17,
    rx: 1.5,
    stroke: "#49454F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxnull);
export default __webpack_public_path__ + "static/media/Checkboxnull.2a5ca7a4108ead1c3f1cfa785057f674.svg";
export { ForwardRef as ReactComponent };